import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
// UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import Error from '../../../components/errors/Error';
import EditorForm from '../../../components/Inputs/formInput/EditorForm';
import InputForm from '../../../components/Inputs/formInput/InputForm';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
// SLICES
import { createFormThunk, updateFormThunk, getFormThunk, initialStateForm } from '../../../store/slices/catalogs/forms.slice';
import { deleteQuestionThunk, initialStateQuestion, } from '../../../store/slices/catalogs/questions.slice';

const FormsForm = () => {
    const { t } = useTranslation();
    const { form_id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setValue, register, handleSubmit, formState: { errors } } = useForm();
    const { item, message, error } = useSelector(state => state.forms);
    const questionState = useSelector(state => state.questions);
    const [text, setText] = useState("");
    const [preguntas, setPreguntas] = useState([{ pregunta: '' }]);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        if (form_id) {
            dispatch(getFormThunk(form_id));
        }
        return () => {
            dispatch(initialStateForm());
        };
    }, [dispatch, form_id]);

    useEffect(() => {
        setValue('titulo', item?.titulo);
        setText(item.descripcion);
        setPreguntas(
            item.questions?.map(pregunta => ({
                id: pregunta.id,
                pregunta: pregunta.textQuestion,
            })) || []
        );
    }, [item, setValue]);

    if (questionState.message === "Registro eliminado correctamente") {
        dispatch(getFormThunk(form_id));
        dispatch(initialStateQuestion());
    }

    const onSubmit = (data) => {
        data.descripcion = text;
        data.questions = preguntas;
        if (form_id) {
            dispatch(updateFormThunk(form_id, data));
        } else {
            dispatch(createFormThunk(data));
        }
    };

    useEffect(() => {
        if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
            navigate(`/panel/forms`);
        }
    }, [message, navigate]);

    const handleChange = (content) => {
        setText(content);
    };

    const handleAgregarPregunta = () => {
        setPreguntas([...preguntas, { id: '', pregunta: '' }]);
    };

    const handleEliminarPregunta = (index) => {
        const nuevasPreguntas = [...preguntas];
        nuevasPreguntas.splice(index, 1);
        setPreguntas(nuevasPreguntas);
    };

    const handleCambiarPregunta = (index, event) => {
        const nuevasPreguntas = [...preguntas];
        nuevasPreguntas[index].pregunta = event.target.value;
        setPreguntas(nuevasPreguntas);
    };

    const handleDeleteQuestion = (id) => {
        dispatch(deleteQuestionThunk(id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5">
                    {error && <Error state={error} />}
                    <HeaderForm title={form_id ? "Editar formulario" : "Nuevo formulario"} />
                    <div className='h-[90%]'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("Titulo de formulario")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    register={register("titulo", { required: true })}
                                    errors={errors.titulo && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>
                            <div className='w-full'>
                                <EditorForm
                                    id="text_one"
                                    label="Descripcion"
                                    spam={true}
                                    cols={1}
                                    onChange={handleChange}
                                    initialValue={text}
                                />
                            </div>
                            <div>
                                {preguntas.map((pregunta, index) => (
                                    <div className='w-full shadow-md shadow-gray-300 rounded-md p-2 border flex gap-3' key={pregunta.id || index}>
                                        <input
                                            className='w-full input input-sm outline-none input-bordered focus:outline-none focus:border-b-[1px] pb-1 bg-slate-100 focus:ring-1 rounded-md shadow-base-400 shadow-md'
                                            type="text"
                                            value={pregunta.pregunta}
                                            onChange={(event) => handleCambiarPregunta(index, event)}
                                            placeholder={`Pregunta ${index + 1}`}
                                        />
                                        <button
                                            type="button"
                                            className='hover:bg-red-300/40 text-[14px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                            onClick={() => pregunta.id ? handleDeleteQuestion(pregunta.id) : handleEliminarPregunta(index)}>
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                ))}
                                <div className='p-2 justify-center w-full flex my-3'>
                                    <button
                                        type="button"
                                        className='hover:bg-green-300/40 text-[15px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                        onClick={handleAgregarPregunta}>
                                        <FaPlus /> Agregar pregunta
                                    </button>
                                </div>
                            </div>
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-orange-500 mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/forms`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default FormsForm;
